/**
 * TIPS AND TRICKS FOR CONTRIBUTORS
 * 1) Memorize the layering of body parts. Hands are higher than arms, feet higher than legs
 * 2) Generally you will want to avoid lower pri items on the same layer sticking out on seams if your object is skintight.
 * In general, this is accomplished by having higher priority items cover more of the original
 */



AddModel({
	Name: "LatexTop",
	Folder: "Chastity",
	Parent: "LatexTop",
	TopLevel: true,
	Categories: ["Bras"],
	Layers: ToLayerMap([
		{ Name: "BraProtoLining", Layer: "BraChest", Pri:-40.1,
			Invariant: true,
			InheritColor: "Latex",
			TieToLayer: "BraProtoLiningRim",
		},
		{ Name: "BraProtoLiningMid", Layer: "StrapsUnderbust", Pri: -40.1,
			Invariant: true,
			InheritColor: "Latex",
			TieToLayer: "BraProtoLiningMidRim",
		},
		{ Name: "BraProtoLiningRim", Layer: "BraChest", Pri:-40,
			Invariant: true,
			InheritColor: "Hem",
		},
		{ Name: "BraProtoLiningMidRim", Layer: "StrapsUnderbust", Pri: -40,
			Invariant: true,
			InheritColor: "Hem",
		},

	])
});



AddModel({
	Name: "LatexTopZip",
	Folder: "Chastity",
	Parent: "LatexTop",
	TopLevel: false,
	Categories: ["Bras"],
	Layers: ToLayerMap([
		{ Name: "BraProtoLiningZip", Layer: "BraChest", Pri: -40.1,
			Invariant: true,
			InheritColor: "Latex",
			TieToLayer: "BraProtoLiningZipRim",
		},
		{ Name: "BraProtoLiningMidZip", Layer: "StrapsUnderbust", Pri: -40.1,
			Invariant: true,
			InheritColor: "Latex",
			TieToLayer: "BraProtoLiningMidZipRim",
		},
		{ Name: "BraProtoLiningZipRim", Layer: "BraChest", Pri: -40,
			Invariant: true,
			InheritColor: "Hem",
		},
		{ Name: "BraProtoLiningMidZipRim", Layer: "StrapsUnderbust", Pri: -40,
			Invariant: true,
			InheritColor: "Hem",
		},

	])
});


AddModel({
	Name: "BraProto",
	Folder: "Chastity",
	Parent: "BraCyber",
	TopLevel: false,
	Restraint: true,
	Categories: ["Restraints", "ChastityBra", "Metal", "SciFi"],
	Filters: {
		Display: {"gamma":1,"saturation":1,"contrast":1.6500000000000001,"brightness":0.8,"red":1,"green":1,"blue":1,"alpha":1},
	},
	Layers: ToLayerMap([
		{ Name: "BraProto", Layer: "BindChestLower", Pri: 14.2-100,
			Invariant: true,
			InheritColor: "Metal",
		},
		{ Name: "BraProtoLining", Layer: "BindChestLower", Pri: 14.1-100,
			Invariant: true,
			InheritColor: "Lining",
		},
		{ Name: "BraProtoLiningMid", Layer: "StrapsUnderbust", Pri: 14-100,
			Invariant: true,
			InheritColor: "Lining",
		},
		{ Name: "BraProtoLiningMidRim", Layer: "StrapsUnderbust", Pri: -14-99.9,
			Invariant: true,
			InheritColor: "Hem",
		},
		{ Name: "BraProtoCups", Layer: "BindChestLower", Pri: 14-100,
			Invariant: true,
			TieToLayer: "BraProto",
			NoOverride: true,
			InheritColor: "Cups",
		},
		{ Name: "BraProtoDisplay", Layer: "BindChestLower", Pri: 14.1-100,
			Invariant: true,
			TieToLayer: "BraProto",
			NoOverride: true,
			InheritColor: "Display",
		},
		{ Name: "BraProtoLock", Layer: "BindChestLower", Pri: 14.2,
			Invariant: true,
			TieToLayer: "BraProto",
			NoOverride: true,
			InheritColor: "Lock",
			LockLayer: true,
		},
	])
});
AddModel(GetModelFashionVersion("BraProto", true));

AddModel({
	Name: "BraCyber",
	Folder: "Chastity",
	Parent: "BraCyber",
	TopLevel: true,
	Restraint: true,
	Categories: ["Restraints", "ChastityBra", "Metal", "SciFi"],
	Filters: {
		Display: {"gamma":1,"saturation":1,"contrast":1.6500000000000001,"brightness":0.8,"red":1,"green":1,"blue":1,"alpha":1},
	},
	Layers: ToLayerMap([
		{ Name: "BraCyber", Layer: "BindChestLower", Pri: 15.1,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			InheritColor: "Metal",
		},
		{ Name: "BraCyberLining", Layer: "BindChestLower", Pri: 15,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			TieToLayer: "BraCyber",
			NoOverride: true,
			InheritColor: "Lining",
		},
		{ Name: "BraCyberDisplay", Layer: "BindChestLower", Pri: 15,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			TieToLayer: "BraCyber",
			NoOverride: true,
			InheritColor: "Display",
		},
		{ Name: "BraCyberLock", Layer: "BindChestLower", Pri: 15.1,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			TieToLayer: "BraCyber",
			NoOverride: true,
			InheritColor: "Lock",
			LockLayer: true,
		},
	])
});
AddModel(GetModelFashionVersion("BraCyber", true));

AddModel({
	Name: "ChastityBra",
	Folder: "Chastity",
	Parent: "ChastityBra",
	TopLevel: true,
	Restraint: true,
	Categories: ["Restraints", "ChastityBra", "Metal"],
	Layers: ToLayerMap([
		{ Name: "BraCups", Layer: "BindChestLower", Pri: -40.1,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			InheritColor: "Metal",
		},
		{ Name: "BraLining", Layer: "BindChestLower", Pri: -40,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			TieToLayer: "BraCups",
			NoOverride: true,
			InheritColor: "Lining",
		},
		{ Name: "BraChain", Layer: "BindChestLower", Pri: -25,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			NoOverride: true,
			InheritColor: "Chain",
		},
		{ Name: "BraLock", Layer: "BindChestLower", Pri: -39,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			TieToLayer: "BraCups",
			NoOverride: true,
			InheritColor: "Lock",
			LockLayer: true,
		},
	])
});
AddModel(GetModelFashionVersion("ChastityBra", true));


AddModel({
	Name: "HeartBelt",
	Folder: "Chastity",
	Parent: "HeartBelt",
	TopLevel: true,
	Restraint: true,
	Categories: ["Restraints", "ChastityBelt", "Metal"],
	AddPose: ["ChastityBelt"],
	AddPoseIf: {
		ChastityOption2: ["CrotchStrap"],
	},
	Layers: ToLayerMap([
		{ Name: "Belt", Layer: "ChastityBelt", Pri: -40.1,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			//DisplacementInvariant: true,
			//DisplacementSprite: "CrotchropeSquished",
			//DisplaceLayers: ToMap(["RibbonTorso"]),
			InheritColor: "Metal",
		},
		{ Name: "BeltLining", Layer: "ChastityBelt", Pri: -40,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			NoOverride: true,
			TieToLayer: "Belt",
			InheritColor: "Lining",
		},
		{ Name: "BeltLock", Layer: "ChastityBelt", Pri: -39.9,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			InheritColor: "Lock",
		},
		{ Name: "BeltStrap", Layer: "ChastityBelt", Pri: -45.1,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			InheritColor: "Metal",
		},
		{ Name: "BeltStrapLining", Layer: "ChastityBelt", Pri: -45,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			NoOverride: true,
			TieToLayer: "BeltStrap",
			InheritColor: "Lining",
		},
	])
});

AddModel(GetModelFashionVersion("HeartBelt", true));


AddModel({
	Name: "CyberBelt",
	Folder: "Chastity",
	Parent: "CyberBelt",
	TopLevel: true,
	Restraint: true,
	Categories: ["Restraints", "ChastityBelt", "Metal", "SciFi"],
	AddPose: ["ChastityBelt"],
	AddPoseIf: {
		ChastityOption2: ["CrotchStrap"],
	},
	Filters: {
		Display: {"gamma":1,"saturation":1,"contrast":1.6500000000000001,"brightness":0.8,"red":1,"green":1,"blue":1,"alpha":1},
	},
	Layers: ToLayerMap([
		{ Name: "Cyber", Layer: "ChastityBelt", Pri: -40,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			//DisplacementInvariant: true,
			//DisplacementSprite: "CrotchropeSquished",
			//DisplaceLayers: ToMap(["RibbonTorso"]),
			InheritColor: "Metal",
		},
		{ Name: "CyberLining", Layer: "ChastityBelt", Pri: -40.1,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			NoOverride: true,
			TieToLayer: "Cyber",
			InheritColor: "Lining",
		},
		{ Name: "CyberDisplay", Layer: "ChastityBelt", Pri: -40.1,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			NoOverride: true,
			TieToLayer: "Cyber",
			InheritColor: "Display",
		},
		{ Name: "CyberPlug", Layer: "ChastityBelt", Pri: -40.1,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			NoOverride: true,
			TieToLayer: "Cyber",
			InheritColor: "Plug",
		},
		{ Name: "CyberLock", Layer: "ChastityBelt", Pri: -40,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			InheritColor: "Lock",
			LockLayer: true,
		},
	])
});
AddModel(GetModelFashionVersion("CyberBelt", true));


AddModel({
	Name: "CyberPanties",
	Folder: "Chastity",
	Parent: "CyberBelt",
	TopLevel: true,
	Categories: ["Underwear", "Panties", "Metal", "SciFi"],
	Layers: ToLayerMap([
		{ Name: "CyberPanties", Layer: "Panties", Pri: -10,
			Invariant: true,
			InheritColor: "Metal",
			MorphPoses: {Closed: "Closed", "Hogtie": "Closed"},
		},
		{ Name: "CyberPantiesLining", Layer: "Panties", Pri: -10.1,
			Invariant: true,
			DisplacementInvariant: true,
			NoOverride: true,
			TieToLayer: "CyberPanties",
			InheritColor: "Lining",
			MorphPoses: {Closed: "Closed", "Hogtie": "Closed"},
		},
	])
});

AddModel({
	Name: "ProtoBelt",
	Folder: "Chastity",
	Parent: "CyberBelt",
	TopLevel: false,
	Restraint: true,
	Categories: ["Restraints", "ChastityBelt", "Metal", "SciFi"],
	AddPose: ["ChastityBelt"],
	AddPoseIf: {
		ChastityOption2: ["CrotchStrap"],
	},
	Filters: {
		Display: {"gamma":1,"saturation":1,"contrast":1.6500000000000001,"brightness":0.8,"red":1,"green":1,"blue":1,"alpha":1},
	},
	//AddPose: ["CrotchStrap"],
	Layers: ToLayerMap([
		{ Name: "Proto", Layer: "ChastityBelt", Pri: 40.1,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			//DisplacementInvariant: true,
			//DisplacementSprite: "CrotchropeSquished",
			//DisplaceLayers: ToMap(["RibbonTorso"]),
			InheritColor: "Metal",
		},
		{ Name: "ProtoLining", Layer: "ChastityBelt", Pri: 40,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			NoOverride: true,
			TieToLayer: "Proto",
			InheritColor: "Lining",
		},
		{ Name: "ProtoDisplay", Layer: "ChastityBelt", Pri: 40,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			NoOverride: true,
			TieToLayer: "Proto",
			InheritColor: "Display",
		},
		{ Name: "ProtoPlug", Layer: "ChastityBelt", Pri: 40,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			NoOverride: true,
			TieToLayer: "Proto",
			InheritColor: "Plug",
		},
		{ Name: "ProtoLock", Layer: "ChastityBelt", Pri: 40.1,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			InheritColor: "Lock",
			LockLayer: true,
		},
	])
});
AddModel(GetModelFashionVersion("ProtoBelt", true));



AddModel({
	Name: "DivineBelt",
	Folder: "DivineBelt",
	Parent: "DivineBelt",
	TopLevel: true,
	Restraint: true,
	Categories: ["Restraints", "ChastityBelt", "Metal", "Divine"],
	AddPose: ["ChastityBelt"],
	AddPoseIf: {
		ChastityOption2: ["CrotchStrap"],
	},
	Layers: ToLayerMap([
		{ Name: "BeltLines", Layer: "ChastityBelt", Pri: 45.2,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			NoColorize: true,
		},
		{ Name: "BeltMetal2", Layer: "ChastityBelt", Pri: 45.1,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			NoOverride: true,
			TieToLayer: "BeltLines",
			InheritColor: "Shield",
		},
		{ Name: "BeltMetal1", Layer: "ChastityBelt", Pri: 45.1,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			NoOverride: true,
			TieToLayer: "BeltLines",
			InheritColor: "Highlights",
		},
		{ Name: "BeltBase", Layer: "ChastityBelt", Pri: 45.0,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			NoOverride: true,
			TieToLayer: "BeltLines",
			InheritColor: "Metal",
		},
		{ Name: "BeltPin", Layer: "ChastityBelt", Pri: 45.1,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			NoOverride: true,
			TieToLayer: "BeltLines",
			InheritColor: "Pin",
		},


		{ Name: "LockBeltLines", Layer: "ChastityBelt", Pri: 45.6,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			NoColorize: true,
			//LockLayer: true,
			TieToLayer: "BeltLines",
		},

		{ Name: "LockBeltPlate", Layer: "ChastityBelt", Pri: 45.3,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			//LockLayer: true,
			TieToLayer: "BeltLines",
			InheritColor: "LockPlate",
		},
		{ Name: "LockBeltShackle", Layer: "ChastityBelt", Pri: 45.4,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			//LockLayer: true,
			TieToLayer: "BeltLines",
			InheritColor: "LockShackle",
		},
		{ Name: "LockBeltHighlight", Layer: "ChastityBelt", Pri: 45.5,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			//LockLayer: true,
			TieToLayer: "BeltLines",
			InheritColor: "LockHighlight",
		},
	])
});
AddModel(GetModelFashionVersion("DivineBelt", true));


AddModel({
	Name: "DivineBeltRunic",
	Folder: "DivineBelt",
	Parent: "DivineBelt",
	TopLevel: false,
	Restraint: true,
	Categories: ["Restraints", "ChastityBelt", "Metal", "Divine"],
	AddPose: ["ChastityBelt"],
	AddPoseIf: {
		ChastityOption2: ["CrotchStrap"],
	},
	Layers: ToLayerMap([
		{ Name: "BeltLines", Layer: "ChastityBelt", Pri: 45.2,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			NoColorize: true,
		},
		{ Name: "BeltMetalRunic2", Layer: "ChastityBelt", Pri: 45.1,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			NoOverride: true,
			TieToLayer: "BeltLines",
			InheritColor: "Shield",
		},
		{ Name: "BeltMetalRunic1", Layer: "ChastityBelt", Pri: 45.1,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			NoOverride: true,
			TieToLayer: "BeltLines",
			InheritColor: "Highlights",
		},
		{ Name: "BeltBase", Layer: "ChastityBelt", Pri: 45.0,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			NoOverride: true,
			TieToLayer: "BeltLines",
			InheritColor: "Metal",
		},
		{ Name: "BeltPin", Layer: "ChastityBelt", Pri: 45.1,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			NoOverride: true,
			TieToLayer: "BeltLines",
			InheritColor: "Pin",
		},


		{ Name: "LockBeltLines", Layer: "ChastityBelt", Pri: 45.6,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			NoColorize: true,
			//LockLayer: true,
			TieToLayer: "BeltLines",
		},

		{ Name: "LockBeltPlate", Layer: "ChastityBelt", Pri: 45.3,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			//LockLayer: true,
			TieToLayer: "BeltLines",
			InheritColor: "LockPlate",
		},
		{ Name: "LockBeltShackle", Layer: "ChastityBelt", Pri: 45.4,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			//LockLayer: true,
			TieToLayer: "BeltLines",
			InheritColor: "LockShackle",
		},
		{ Name: "LockBeltHighlight", Layer: "ChastityBelt", Pri: 45.5,
			//swaplayerpose: {Kneel: "ChastityBeltLower", KneelClosed: "ChastityBeltLower"},
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			//LockLayer: true,
			TieToLayer: "BeltLines",
			InheritColor: "LockHighlight",
		},
	])
});
AddModel(GetModelFashionVersion("DivineBeltRunic", true));

AddModel({
	Name: "DivineBra",
	Folder: "DivineBelt",
	Parent: "DivineBra",
	TopLevel: true,
	Restraint: true,
	Categories: ["Restraints", "ChastityBra", "Metal", "Divine"],
	Layers: ToLayerMap([
		{ Name: "BraLines", Layer: "BindChestLower", Pri: 10.3,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			NoColorize: true,
		},
		{ Name: "BraBase1", Layer: "BindChestLower", Pri: 10,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			TieToLayer: "BraLines",
			NoOverride: true,
			InheritColor: "Metal",
		},
		{ Name: "BraBase2", Layer: "BindChestLower", Pri: 10,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			TieToLayer: "BraLines",
			NoOverride: true,
			InheritColor: "Chest",
		},
		{ Name: "BraMetal1", Layer: "BindChestLower", Pri: 10.1,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			TieToLayer: "BraLines",
			NoOverride: true,
			InheritColor: "Highlights",
		},
		{ Name: "BraMetal2", Layer: "BindChestLower", Pri: 10.1,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			TieToLayer: "BraLines",
			NoOverride: true,
			InheritColor: "Center",
		},
		{ Name: "BraPins", Layer: "BindChestLower", Pri: 10.1,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			TieToLayer: "BraLines",
			NoOverride: true,
			InheritColor: "Pins",
		},
		{ Name: "BraStraps", Layer: "BindChestLower", Pri: 10.1,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			TieToLayer: "BraLines",
			NoOverride: true,
			InheritColor: "Straps",
		},
		{ Name: "LockBraLines", Layer: "BindChestLower", Pri: 10.6,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			TieToLayer: "BraLines",
			NoOverride: true,
			NoColorize: true,
			//LockLayer: true,
		},
		{ Name: "LockBraPlate", Layer: "BindChestLower", Pri: 10.3,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			TieToLayer: "BraLines",
			NoOverride: true,
			InheritColor: "LockPlate",
			//LockLayer: true,
		},
		{ Name: "LockBraShackle", Layer: "BindChestLower", Pri: 10.4,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			TieToLayer: "BraLines",
			NoOverride: true,
			InheritColor: "LockShackle",
			//LockLayer: true,
		},
		{ Name: "LockBraHighlight", Layer: "BindChestLower", Pri: 10.5,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			TieToLayer: "BraLines",
			NoOverride: true,
			InheritColor: "LockHighlight",
			//LockLayer: true,
		},
	])
});
AddModel(GetModelFashionVersion("DivineBra", true));


AddModel({
	Name: "DivineBraRunic",
	Folder: "DivineBelt",
	Parent: "DivineBra",
	TopLevel: false,
	Restraint: true,
	Categories: ["Restraints", "ChastityBra", "Metal", "Divine"],
	Layers: ToLayerMap([
		{ Name: "BraLines", Layer: "BindChestLower", Pri: 10.3,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			NoColorize: true,
		},
		{ Name: "BraBase1", Layer: "BindChestLower", Pri: 10,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			TieToLayer: "BraLines",
			NoOverride: true,
			InheritColor: "Metal",
		},
		{ Name: "BraBase2", Layer: "BindChestLower", Pri: 10,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			TieToLayer: "BraLines",
			NoOverride: true,
			InheritColor: "Chest",
		},
		{ Name: "BraMetalRunic1", Layer: "BindChestLower", Pri: 10.1,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			TieToLayer: "BraLines",
			NoOverride: true,
			InheritColor: "Highlights",
		},
		{ Name: "BraMetalRunic2", Layer: "BindChestLower", Pri: 10.1,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			TieToLayer: "BraLines",
			NoOverride: true,
			InheritColor: "Center",
		},
		{ Name: "BraPins", Layer: "BindChestLower", Pri: 10.1,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			TieToLayer: "BraLines",
			NoOverride: true,
			InheritColor: "Pins",
		},
		{ Name: "BraStrapsRunic", Layer: "BindChestLower", Pri: 10.1,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			TieToLayer: "BraLines",
			NoOverride: true,
			InheritColor: "Straps",
		},
		{ Name: "LockBraLines", Layer: "BindChestLower", Pri: 10.6,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			TieToLayer: "BraLines",
			NoOverride: true,
			NoColorize: true,
			//LockLayer: true,
		},
		{ Name: "LockBraPlate", Layer: "BindChestLower", Pri: 10.3,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			TieToLayer: "BraLines",
			NoOverride: true,
			InheritColor: "LockPlate",
			//LockLayer: true,
		},
		{ Name: "LockBraShackle", Layer: "BindChestLower", Pri: 10.4,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			TieToLayer: "BraLines",
			NoOverride: true,
			InheritColor: "LockShackle",
			//LockLayer: true,
		},
		{ Name: "LockBraHighlight", Layer: "BindChestLower", Pri: 10.5,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			TieToLayer: "BraLines",
			NoOverride: true,
			InheritColor: "LockHighlight",
			//LockLayer: true,
		},
	])
});
AddModel(GetModelFashionVersion("DivineBraRunic", true));



AddModel({
	Name: "SteelChastityBelt_Padlock",
	Folder: "SteelChastity",
	Parent: "SteelChastityBelt_Padlock",
	TopLevel: true,
	Restraint: true,
	Categories: ["Restraints", "ChastityBelt", "Metal"],
	AddPose: ["ChastityBelt", "NeoBelt", "NeoChastityBelt"],
	AddPoseIf: {
		ChastityOption2: ["CrotchStrap"],
	},
	//AddPose: ["CrotchStrap"],
	Layers: ToLayerMap([
		{ Name: "Belt", Layer: "ChastityBelt", Pri: -40.1,
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			DisplacementSprite: "TightBelt",
			DisplaceAmount: 100,
			DisplaceLayers: ToMap(["TightChastityBelt"]),
			InheritColor: "BaseMetal",
		},
		{ Name: "BeltPadlock", Layer: "ChastityBelt", Pri: -39.9,
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			InheritColor: "Lock",
			TieToLayer: "Belt",
		},
		{ Name: "BeltPadlockPin", Layer: "ChastityBelt", Pri: -39.8,
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			InheritColor: "LockPin",
			TieToLayer: "Belt",
		},
	])
});
AddModel({
	Name: "SteelChastityBelt_Radial",
	Folder: "SteelChastity",
	Parent: "SteelChastityBelt_Padlock",
	TopLevel: false,
	Restraint: true,
	Categories: ["Restraints", "ChastityBelt", "Metal"],
	AddPose: ["ChastityBelt", "NeoBelt", "NeoChastityBelt"],
	AddPoseIf: {
		ChastityOption2: ["CrotchStrap"],
	},
	//AddPose: ["CrotchStrap"],
	Layers: ToLayerMap([
		{ Name: "Belt", Layer: "ChastityBelt", Pri: -40.1,
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			DisplacementSprite: "TightBelt",
			DisplaceAmount: 100,
			DisplaceLayers: ToMap(["TightChastityBelt"]),
			InheritColor: "BaseMetal",
		},
		{ Name: "BeltRadial", Layer: "ChastityBelt", Pri: -39.9,
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			InheritColor: "Lock",
			TieToLayer: "Belt",
		},
	])
});
AddModel({
	Name: "SteelChastityBelt_Segu",
	Folder: "SteelChastity",
	Parent: "SteelChastityBelt_Padlock",
	TopLevel: false,
	Restraint: true,
	Categories: ["Restraints", "ChastityBelt", "Metal"],
	AddPose: ["ChastityBelt", "NeoBelt", "NeoChastityBelt"],
	AddPoseIf: {
		ChastityOption2: ["CrotchStrap"],
	},
	//AddPose: ["CrotchStrap"],
	Layers: ToLayerMap([
		{ Name: "Belt", Layer: "ChastityBelt", Pri: -40.1,
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			DisplacementSprite: "TightBelt",
			DisplaceAmount: 100,
			DisplaceLayers: ToMap(["TightChastityBelt"]),
			InheritColor: "BaseMetal",
		},
		{ Name: "BeltSegu", Layer: "ChastityBelt", Pri: -39.9,
			PrependLayerPrefix: {ChastityOption2: "Option2_", ChastityOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			InheritColor: "Lock",
			TieToLayer: "Belt",
		},
	])
});

AddModel(GetModelFashionVersion("SteelChastityBelt_Padlock", true));
AddModel(GetModelFashionVersion("SteelChastityBelt_Radial", true));
AddModel(GetModelFashionVersion("SteelChastityBelt_Segu", true));



AddModel({
	Name: "SteelChastityBra_Padlock",
	Folder: "SteelChastity",
	Parent: "SteelChastityBra_Padlock",
	TopLevel: true,
	Restraint: true,
	Categories: ["Restraints", "ChastityBra", "Metal"],
	//AddPose: ["CrotchStrap"],
	Layers: ToLayerMap([
		{ Name: "Bra", Layer: "BindChestLower", Pri: -30.1,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			InheritColor: "BaseMetal",
		},
		{ Name: "BraPadlock", Layer: "BindChestLower", Pri: -29.9,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			InheritColor: "Lock",
			TieToLayer: "Bra",
		},
		{ Name: "BraPadlockPin", Layer: "BindChestLower", Pri: -29.8,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			InheritColor: "LockPin",
			TieToLayer: "Bra",
		},
	])
});
AddModel({
	Name: "SteelChastityBra_Radial",
	Folder: "SteelChastity",
	Parent: "SteelChastityBra_Padlock",
	TopLevel: false,
	Restraint: true,
	Categories: ["Restraints", "ChastityBra", "Metal"],
	//AddPose: ["CrotchStrap"],
	Layers: ToLayerMap([
		{ Name: "Bra", Layer: "BindChestLower", Pri: -30.1,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			InheritColor: "BaseMetal",
		},
		{ Name: "BraRadial", Layer: "BindChestLower", Pri: -29.9,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			InheritColor: "Lock",
			TieToLayer: "Bra",
		},
	])
});
AddModel({
	Name: "SteelChastityBra_Segu",
	Folder: "SteelChastity",
	Parent: "SteelChastityBra_Padlock",
	TopLevel: false,
	Restraint: true,
	Categories: ["Restraints", "ChastityBra", "Metal"],
	//AddPose: ["CrotchStrap"],
	Layers: ToLayerMap([
		{ Name: "Bra", Layer: "BindChestLower", Pri: -30.1,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			InheritColor: "BaseMetal",
		},
		{ Name: "BraSegu", Layer: "BindChestLower", Pri: -29.9,
			PrependLayerPrefix: {ChastityBraOption: "Option_"},
			Invariant: true,
			DisplacementInvariant: true,
			InheritColor: "Lock",
			TieToLayer: "Bra",
		},
	])
});

AddModel(GetModelFashionVersion("SteelChastityBra_Padlock", true));
AddModel(GetModelFashionVersion("SteelChastityBra_Radial", true));
AddModel(GetModelFashionVersion("SteelChastityBra_Segu", true));